import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-create_project",
  "use": "icon-create_project-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-create_project\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M17.33,6H6.67A.67.67,0,0,0,6,6.67V17.33a.67.67,0,0,0,.67.67H17.33a.67.67,0,0,0,.67-.67V6.67A.67.67,0,0,0,17.33,6Zm-2,6.67H12.67v2.66H11.33V12.67H8.67V11.33h2.66V8.67h1.34v2.66h2.66Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol